<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Visitors'}">
              <h4 class="ms-2">
                {{label.pages.visitors}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.resumeList}}
              </small>
            </h4>
          </b-col>
          <b-col sm="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="resumes"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <DxColumnChooser
                :enabled="true"
                mode="dragAndDrop"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                        variant="ps-info"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.activityFields"
                        @click="showActivity"
                    >
                      <b-icon icon="briefcase-fill" scale="1.2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-0">
                  <button
                      @click="detail(data)"
                      v-b-tooltip.hover
                      :title="label.pages.shoeDetails"
                  >
                    <b-icon icon="filter-square-fill" scale="1.1" variant="ps-tools-icon"></b-icon>
                  </button>
                </b-col>
                <b-col cols="auto" class="px-0">
                  <button
                      @click="delConfirm(data)"
                      v-b-tooltip.hover
                      :title="label.pages.delete"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                </b-col>
                <b-col cols="auto" class="px-0" v-if="data.data.fileAddress">
                  <button
                      @click="download(data)"
                      v-b-tooltip.hover
                      :title="label.pages.downloadResume"
                  >
                    <b-icon icon="arrow-down-square-fill" scale="1.1" variant="ps-add-icon"></b-icon>
                  </button>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Detail Modal -->
    <b-modal
        dir="rtl"
        v-model="detModal"
        centered
        hide-footer
        hide-header
        size="sm"
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center">
            <small> {{label.pages.firstName}}: </small>
            <strong class="me-2"> {{ resume.firstName }} </strong>
          </p>
          <p class="fs10 text-center">
            <small> {{label.pages.lastName}}: </small>
            <strong class="me-2"> {{ resume.lastName }} </strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.form.phoneNumber}}: </small>
            <strong class="me-2"> {{ resume.mobileNumber }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.email}}: </small>
            <strong class="me-2"> {{ resume.mobileNumber }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.areaOfActivity}}: </small>
            <strong class="me-2"> {{ resume.activityFieldTitle }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.description}}: </small>
            <strong class="me-2"> {{ resume.description }}</strong>
          </p>
          <p class="fs10 text-center">
            <small>{{label.pages.dateOfSendResume}}: </small>
            <strong class="me-2"> {{ resume.createdLocal }}</strong>
          </p>
          <b-button variant="ps-primary" :href="resume.fileAddress" target="_blank">{{label.pages.resumeFile}}</b-button>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="detModal=false"
            >
            {{label.pages.cansel}}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteResumeConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deletePost"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- Show Activity Modal -->
    <b-modal
        dir="rtl"
        v-model="activityModal"
        header-bg-variant="ps-info"
        size="md"
        centered
    >
        <template #modal-header>
          <h4 class="text-white fw1 p-0 m-0 py-2">
          {{ label.buttons.activityFields }}
          </h4>
          <button
              class="ps-closeModalBtn"
              @click="activityModal=false"
              id="closeActivityModalBtnTlp"
          >
            <b-icon icon="x-square"></b-icon>
          </button>
          <b-tooltip
            boundary="#app"
            noninteractive
            triggers="hover"
            target="closeActivityModalBtnTlp"
          >
            {{ label.pages.closeTab }}
          </b-tooltip>
        </template>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <DxDataGrid
                :show-row-lines="true"
                :show-column-lines="true"
                :show-borders="true"
                :row-alternation-enabled="true"
                :rtl-enabled="true"
                :data-source="activities"
                :columns="activityFields"
                :column-auto-width="true"
                :hover-state-enabled="true"
                :noDataText="checkData"
                key-expr="id"
                class="ps_Table"
            >
              <template #radif="{data}">
                <div>
                  {{ data.rowIndex + 1 }}
                </div>
              </template>
              <template #actions="{data}">
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="px-0">
                    <button
                        @click="edit(data)"
                        :id="'editBtnTlp-' + data.data.id"
                    >
                      <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                    </button>
                    <b-tooltip
                      boundary="#app"
                      noninteractive
                      triggers="hover"
                      :target="'editBtnTlp-' + data.data.id"
                    >
                      {{ label.buttons.edit }}
                    </b-tooltip>
                  </b-col>
                  <b-col cols="auto" class="px-0 pe-2">
                    <button
                        @click="delActivityConfirm(data)"
                        :id="'deleteActBtnTlp-' + data.data.id"
                    >
                      <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                    </button>
                    <b-tooltip
                      boundary="#app"
                      noninteractive
                      triggers="hover"
                      :target="'deleteActBtnTlp-' + data.data.id"
                    >
                      {{ label.buttons.delete }}
                    </b-tooltip>
                  </b-col>
                </b-row>
              </template>
              <DxLoadPanel :enabled="true"/>
              <DxScrolling mode="virtual"/>
            </DxDataGrid>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="activityModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="add"
            >
            {{label.buttons.addActivityField}}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Add Activity Modal -->
    <b-modal
        dir="rtl"
        v-model="addActivityModal"
        header-bg-variant="ps-success"
        header-class="p-2"
        centered
        size="sm"
    >
      <template #modal-header>
        <h4 class="text-white fw1 p-0 m-0 py-2">
        {{label.buttons.addActivityField}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addActivityModal=false"
            id="closeAddModalBtnTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalBtnTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="my-2">
          <b-col class="mb-1" sm="3">
            <label for="title" class="ps_label">
              {{label.form.title}}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" v-model="activityTitle" size="sm"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="addActivityModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1 fs8"
                @click="addActivity"
            >
            {{label.buttons.submit}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-success"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Edit Activity Modal -->
    <b-modal
        dir="rtl"
        v-model="editActivityModal"
        header-bg-variant="ps-warning"
        header-class="p-2"
        centered
        size="sm"
    >
      <template #modal-header>
        <h4 class="text-white fw1 p-0 m-0 py-2">
          {{label.pages.editOfIntroduction}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editActivityModal=false"
            id="closeEditModalBtnTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalBtnTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="my-2">
          <b-col class="mb-1" sm="3">
            <label for="title" class="ps_label">
              {{label.form.title}}
              <span class="ps_label_star">*</span>
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="title" v-model="activityTitle" size="sm"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="editActivityModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1 fs8"
                @click="editActivity"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-warning"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Activity Modal -->
    <b-modal
        dir="rtl"
        v-model="deleteActivityModal"
        hide-header
        centered
        size="sm"
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ activityTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1 fs8"
                @click="deleteActivityModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1 fs8"
                @click="deleteActivity"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import label from "@/plugins/StaticLabels.js";
import alert from '@/plugins/AlertMessages.js'

export default {
  name: 'ResumePage',
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          alignment: 'center'
        },
        {
          dataField: 'firstName',
          caption: 'نام',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'lastName',
          caption: 'نام خانوادگی',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'activityFieldTitle',
          caption: 'تخصص',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'createdLocal',
          caption: 'تاریخ ثبت',
          dataType: 'string',
          alignment: 'center'
        },
        {
          dataField: 'isSeen',
          caption: 'وضعیت (خوانده شده)',
          dataType: 'boolean',
          alignment: 'center'
        },
      ],
      delId: null,
      delModal: false,
      delTitle: null,
      detModal: null,

      activityFields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '80px',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '80px',
          alignment: 'center'
        },
        {
          dataField: 'title',
          caption: 'عنوان',
          dataType: 'string',
          alignment: 'center'
        },
      ],
      activityModal: false,
      addActivityModal: false,
      editActivityModal: false,
      deleteActivityModal: false,
      activityTitle: null,
      activityId: null
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      resumes: 'baseX/resumes',
      resume: 'baseX/resume',
      activities: 'baseX/activityFields',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.addActivityModal = false;
        this.editActivityModal = false;
        this.deleteActivityModal = false;
        this.reloadFields();
        this.reloadData();
      }
    },
  },
  methods: {
    detail(item) {
      const ids = [];
      ids.push(item.data.id);
      this.$store.dispatch('baseX/isAdminReadResume', ids);
      this.$store.dispatch('baseX/getResumeById', item.data.id);
      this.detModal = true;
    },
    delConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.firstName + ' ' + item.data.lastName;
      this.delModal = true;
    },
    deletePost() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteResume', this.delId);
      this.delModal = false;
    },
    download(item) {
      window.open(item.data.fileAddress, '_blank');
    },
    showActivity() {
      this.activityModal = true;
    },
    add() {
      this.reloadFields();
      this.addActivityModal = true;
    },
    addActivity() {
      this.$store.commit("setLoadingBtn", true);
      if(this.activityTitle && this.activityTitle != ''){
        const payload = {
          title: this.activityTitle,
        };
        this.$store.dispatch('baseX/addActivityField', payload);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty);
      }
    },
    edit(item) {
      this.activityTitle = item.data.title;
      this.activityId = item.data.id;
      this.editActivityModal = true;
    },
    editActivity() {
      this.$store.commit("setLoadingBtn", true);
      if(this.activityTitle && this.activityTitle != ''){
        const payload = {
          id: this.activityId,
          value: {
            title: this.activityTitle,
          },
        };
        this.$store.dispatch('baseX/editActivityField', payload);
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty);
      }
    },
    delActivityConfirm(item) {
      this.activityTitle = item.data.title;
      this.activityId = item.data.id;
      this.deleteActivityModal = true;
    },
    deleteActivity() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteActivityField', this.activityId);
      this.deleteActivityModal = false;
    },
    reloadFields() {
      this.activityTitle = null;
      this.activityId = null;
    },
    reloadData() {
      this.$store.dispatch('baseX/getResumes');
      this.$store.dispatch('baseX/getActivityFields');
    },
  },
  mounted() {
    this.reloadData();
  },
}
</script>
